import React, { Component } from 'react'
import {
    Link,
    browserHistory,
    Redirect,
    withRouter,
} from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, FormattedNumber, injectIntl, defineMessages } from 'react-intl'
import FormattedInputField from '../../sharedComponents/formattedInputField.component.jsx'
import GlobalHelper from '../../common/GlobalHelper.jsx'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import ProductSearchSelect from "./productsearchselect.component.jsx"
import ExternalShippingMethodSelect from './ExternalShippingMethodSelect.component'
import { CreatedExternalShippingMethodsMapping } from '../../state/fee/helpers/FeeExternalShippingMappingHelper'
import Integrations from '../../integration/Integrations.jsx'
import { Form } from 'react-bootstrap'
import { TYPE_LATE_FEE } from '../../state/fee/feeTypes'
import FeeService from '../../state/fee/FeeService'
import {INTEGRATION_KEY} from "../../state/integration/Constants";

const messages = defineMessages({
    "percentage": {
        id: 'settings.fees.editform.rate_type.percentage',
        defaultMessage: 'percentage',
    },
    "flat_amount": {
        id: 'ettings.fees.editform.rate_type.flat_amount',
        defaultMessage: 'flat-amount',
    },
    "on_due_date": {
        id: 'settings.fees.editform.late_fee.on_due_date_label',
        defaultMessage: 'Starting on the due date',
    },
    "days_after_due_date": {
        id: 'settings.fees.editform.late_fee.days_after_due_date_label',
        defaultMessage: 'Days after the due date',
    },
    "save_btn": {
        id: 'fee.form.edit.save_btn',
        defaultMessage: 'Save',
    },
    "name_placeholder": {
        id: 'fee.form.edit.name_placeholder',
        defaultMessage: 'Fee name',
    }
})


const redirectEndpoint = '/settings/fees/listing'

class FeeEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        //get feeType from url params
        const search = window.location.search
        const query = new URLSearchParams(search);
        const feeType = query.get('feeType')

        this.state = {
            id: '',
            name: '',
            feeType: this.props.createType || feeType,
            rateType: GlobalHelper.hasOneOfTheLightspeedEcomIntegrations() ? 'flat-rate' : '',
            rate: '',
            taxExempt: false,
            formStatus: '',
            deleteButton: '',
            // integrationKey => external product
            externalProductsMapping: {},
            // integrationKey => external shipping method
            externalShippingMethodsMapping: {},
            daysAfterDueDate: '1',
            isLateFeeOnDueDate: true,
        }

        this.submitFee = this.submitFee.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteFee = this.deleteFee.bind(this)
        this.updateProducts = this.updateProducts.bind(this)
        this.updateShippingMethods = this.updateShippingMethods.bind(this)
        this.updateFeeRateType = this.updateFeeRateType.bind(this)
    }


    componentDidMount() {
        const fee = this.props.fee

        const externalProductsMapping = this.createdExternalProductsMapping(fee)
        const externalShippingMethodsMapping = CreatedExternalShippingMethodsMapping(fee)
        if (fee && fee.id) {
            const deleteButton = <ConfirmButton identifier={fee.attributes.name} onClick={this.deleteFee} className="btn btn-danger">
                <FormattedMessage
                    id="fee.form.edit.delete_btn"
                    defaultMessage="Delete fee"
                />
            </ConfirmButton>

            this.setState({
                id: fee.id,
                name: fee.attributes.name,
                rateType: fee.attributes.rateType,
                rate: fee.attributes.rate,
                taxExempt: fee.attributes.taxExempt,
                daysAfterDueDate: fee.attributes.daysAfterDueDate === 0 ? "1" : fee.attributes.daysAfterDueDate,
                isLateFeeOnDueDate: fee.attributes.daysAfterDueDate === 0,
                deleteButton: deleteButton,
                externalProductsMapping: externalProductsMapping,
                externalShippingMethodsMapping: externalShippingMethodsMapping,
            })
        } else {
            this.setState({
                externalProductsMapping: externalProductsMapping,
                externalShippingMethodsMapping: externalShippingMethodsMapping,
            })
        }
    }

    async deleteFee() {
        const r = await FeeService.delete(this.state.id)
        if (!r.isError) {
            const endpoint = redirectEndpoint + `?feeType=${this.state.feeType}`
            this.props.history.push(endpoint) //doing redirect here.
        }
    }

    saveFee() {
        const fee = this.props.fee

        const externalProducts = Object.entries(this.state.externalProductsMapping)
            .filter(([k, v]) => v != null)
            .map(([k, v]) => v)
        const externalShippingMethods = Object.entries(this.state.externalShippingMethodsMapping)
            .filter(([k, v]) => v != null)
            .map(([k, v]) => v)

        if (fee && fee.id) {
            let updates = {}
            const allowedTaxFields = [
                "name",
                "rate",
                "rateType",
                "taxExempt",
                "daysAfterDueDate",
                "feeType",
            ]
            for (let i = 0; i < allowedTaxFields.length; i++) {
                let field = allowedTaxFields[i]
                if (fee.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }

            if (this.state.isLateFeeOnDueDate && this.state.feeType === TYPE_LATE_FEE) {
                updates["daysAfterDueDate"] = "0"
            }
            updates["externalProducts"] = externalProducts
            updates["externalShippingMethods"] = externalShippingMethods
            return AppContext.getApiClient().patch('/fees/' + fee.id, updates)
        } else {
            let payload = {
                "name": this.state.name,
                "rateType": this.state.rateType,
                "rate": this.state.rate,
                "taxExempt": this.state.taxExempt,
                "externalProducts": externalProducts,
                "externalShippingMethods": externalShippingMethods,
                "feeType": this.state.feeType,
            }

            if (this.state.feeType === TYPE_LATE_FEE) {
                if (!this.state.isLateFeeOnDueDate) {
                    payload["daysAfterDueDate"] = this.state.daysAfterDueDate
                } else {
                    payload["daysAfterDueDate"] = "0"
                }
            }
            return AppContext.getApiClient().post(`/fees/${this.state.feeType}`, payload)
        }
    }

    submitFee(event) {
        this.saveFee().then((response) => {
            if (!response.error) {
                const endpoint = redirectEndpoint + `?feeType=${this.state.feeType}`
                this.props.history.push(endpoint) //doing redirect here.
            }
        })
        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    updateProducts(product, integrationKey) {
        let mapping = this.state.externalProductsMapping
        mapping[integrationKey] = product
        this.setState({
            externalProductsMapping: mapping
        })
    }

    updateFeeRateType(rateType) {
        this.setState({
            rateType: rateType
        })
    }

    isShippingFee() {
        return (
            (!this.state.id && this.state.rateType === 'flat-rate') ||
            (this.props.fee && this.props.fee.attributes.isShippingFee)
        )
    }

    getIntegrationsSupportingExternalProduct() {
        let integrations = []
        if (GlobalHelper.hasLightspeedIntegration()) {
            integrations.push(INTEGRATION_KEY.LIGHTSPEED_RETAIL)
        }
        if (GlobalHelper.hasLightspeedEcomIntegration()) {
            integrations.push('ls-ecom')
        }
        if (GlobalHelper.hasVendIntegration()) {
            integrations.push(INTEGRATION_KEY.VEND)
        }
        return integrations
    }

    createdExternalProductsMapping(fee) {
        const externalProducts = fee && fee.attributes.externalProducts || []

        let externalProductsMapping = {}
        for (const prod of externalProducts) {
            externalProductsMapping[prod.attributes.integrationKey] = this.formatProduct(prod)
        }

        for (const integrationKey of this.getIntegrationsSupportingExternalProduct()) {
            if (!externalProductsMapping[integrationKey]) {
                externalProductsMapping[integrationKey] = null
            }
        }
        return externalProductsMapping
    }

    formatProduct(product) {
        return {
            externalId: product.id,
            title: product.attributes.title,
            integrationKey: product.attributes.integrationKey,
        }
    }

    updateShippingMethods(shippingMethod, integrationKey) {
        let mapping = this.state.externalShippingMethodsMapping
        mapping[integrationKey] = shippingMethod
        this.setState({
            externalShippingMethodsMapping: mapping
        })
    }

    renderFeeRate() {
        const onValueChange = (newValue) => {
            this.setState({
                rate: newValue
            })
        }

        const messages = {
            'percentage-rate_description': <FormattedMessage
                id="fee.form.edit.rate_description"
                defaultMessage="Percentage rate of the fee"
            />,
            'flat-rate_description': <FormattedMessage
                id="fee.form.edit.flat_rate_description"
                defaultMessage="Flat amount of the fee"
            />
        }

        let { feeLabel, inputGroupText } = GlobalHelper.GetLabelAndSign(this.state.rateType)
        return (

            <div className="example-collapse-text form-group row">
                <label className="col-2 col-form-label text-align-right" htmlFor={this.state.rateType}>
                    {feeLabel}
                </label>
                <div className="col-10">
                    <div className="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">{inputGroupText}
                            </span>
                        </div>
                        <FormattedInputField
                            name="rate"
                            id={'rate'}
                            type="text"
                            className="form-control"
                            placeholder={GlobalHelper.applyLocaleDecimal("5.5", AppContext.getLocale().getLanguage())}
                            valueType="money"
                            value={this.state.rate}
                            onValueChange={onValueChange}
                            allowNegative={false}
                        />
                    </div>
                    <small className="form-text text-muted">
                        {messages[`${this.state.rateType}_description`]}
                    </small>
                </div>
            </div>
        )
    }

    render() {
        return (
            < form onSubmit={this.submitFee} >
                {this.state.formStatus}
                < div className="row ui-has-modules" >
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="fee.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>

                            <div className="col-10">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["name_placeholder"])}
                                    required
                                />

                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="fee.form.edit.name_description"
                                        defaultMessage="Fee name displayed on proposal total"
                                    />
                                </small>
                            </div>
                        </div>

                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="fee.form.edit.fee_select_label"
                                    defaultMessage="Select a fee type"
                                />
                            </label>
                            <div className="col-10">
                                <Form>
                                    <div key='default-radio' className="mt-2 mb-3">
                                        {!GlobalHelper.hasOneOfTheLightspeedEcomIntegrations() &&
                                            <Form.Check
                                                type='radio'
                                                id='percentage'
                                                name="group1"
                                                label={this.props.intl.formatMessage(messages.percentage)}
                                                checked={this.state.rateType !== 'flat-rate' || this.state.rateType === ""}
                                                onChange={() => this.updateFeeRateType('percentage-rate')}
                                            />
                                        }
                                        <Form.Check
                                            type='radio'
                                            label={this.props.intl.formatMessage(messages.flat_amount)}
                                            id='flat-amount'
                                            name="group1"
                                            checked={this.state.rateType === 'flat-rate' || GlobalHelper.hasOneOfTheLightspeedEcomIntegrations()}
                                            onChange={() => this.updateFeeRateType('flat-rate')}
                                        />
                                    </div>
                                </Form>
                            </div>
                        </div>

                        {this.renderFeeRate()}
                        {this.isShippingFee() && GlobalHelper.hasOneOfTheLightspeedEcomIntegrations() &&
                            Object.entries(this.state.externalShippingMethodsMapping)
                                .map(([integrationKey, shippingMethod]) => {
                                    return integrationKey &&
                                        <ExternalShippingMethodSelect
                                            key={"select-shipping-method-" + integrationKey}
                                            integrationKey={integrationKey}
                                            selectionCallback={selectedShippingMethod => {
                                                this.updateShippingMethods(selectedShippingMethod, integrationKey)
                                            }}
                                            shippingMethod={shippingMethod}
                                        />
                                })}
                        {!GlobalHelper.hasOneOfTheLightspeedEcomIntegrations() &&
                            !GlobalHelper.hasShopifyIntegration() && !GlobalHelper.hasShopifyExpertAppIntegration() &&
                            Object.entries(this.state.externalProductsMapping)
                                .map(([integrationKey, product]) => {
                                    return integrationKey &&
                                        <ProductSearchSelect
                                            key={"select-product-" + integrationKey}
                                            integrationKey={integrationKey}
                                            callback={p => this.updateProducts(p, integrationKey)}
                                            product={product}
                                            label={
                                                <div className="col-2 col-form-label text-align-right">
                                                    <FormattedMessage
                                                        id="fee.form.edit.product.external_product_label"
                                                        defaultMessage="External Product for {integrationLogo}"
                                                        values={{
                                                            integrationLogo: Integrations.getIntegrationLogoImage(integrationKey, '75')
                                                        }}
                                                    />
                                                </div>
                                            }
                                            colSize={10}
                                        />
                                })
                        }

                        <div className={"form-group row"}>
                            <div className="col-2 col-form-label text-align-right" />
                            <div className="col-10">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="taxExempt"
                                        name="taxExempt"
                                        onChange={this.handleFormChange}
                                        checked={this.state.taxExempt}
                                    />

                                    <label className="custom-control-label" htmlFor="taxExempt">
                                        <FormattedMessage
                                            id="fee.form.edit.pricing.tax_exempt_label"
                                            defaultMessage="Tax exempt"
                                        />
                                    </label>
                                </div>

                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="product.form.edit.pricing.tax_exempt_description"
                                        defaultMessage="This option will exempt tax from the quote/invoice of the fee."
                                    />
                                </small>
                            </div>
                        </div>

                        {this.state.feeType === TYPE_LATE_FEE &&
                            <div className={"form-group row"}>
                                <div className="col-2 col-form-label text-align-right" />
                                <div className="col-10">
                                    <div key='default-radio' className="mt-2 mb-3">
                                        <Form.Check
                                            type='radio'
                                            id='dueOnDueDate'
                                            name="group2"
                                            label={this.props.intl.formatMessage(messages.on_due_date)}
                                            checked={this.state.isLateFeeOnDueDate}
                                            onChange={() => this.setState({
                                                isLateFeeOnDueDate: true
                                            })}
                                        />

                                        <Form.Check
                                            type='radio'
                                            label={this.props.intl.formatMessage(messages.days_after_due_date)}
                                            id='manualDays'
                                            name="group2"
                                            checked={!this.state.isLateFeeOnDueDate}
                                            onChange={() => this.setState({
                                                isLateFeeOnDueDate: false,
                                            })}
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        {!this.state.isLateFeeOnDueDate && this.state.feeType === TYPE_LATE_FEE &&
                            <div className="form-group row">
                                <div className="col-2 col-form-label text-align-right" />
                                <div className="col-10">
                                    <div className="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <FormattedMessage
                                                    id="fee.form.edit.late_fee_days"
                                                    defaultMessage="days"
                                                />
                                            </span>
                                        </div>
                                        <input
                                            type="number"
                                            className="form-control"
                                            min="1"
                                            value={this.state.daysAfterDueDate}
                                            onChange={(e) => {
                                                this.setState({
                                                    daysAfterDueDate: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="fee.form.edit.late_fee_days_description"
                                            defaultMessage="Number of days after the due date"
                                        />
                                    </small>
                                </div>
                            </div>
                        }
                    </div>


                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>

                            <div className="col-6 text-align-right">
                                <Link to={redirectEndpoint + `?feeType=${this.state.feeType}`} className="btn btn-light mr-2">
                                    <FormattedMessage
                                        id="tax.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                <input type="submit" value={this.props.intl.formatMessage(messages['save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div >
            </form >
        );
    }
}

export default withRouter(injectIntl(FeeEditForm))


// WEBPACK FOOTER //
// ./src/settings/fees/editform.component.jsx